import React from 'react';
import styled from 'styled-components';

interface AthleteChoiceModalProps {
  onClose: () => void;
  onSelectCreateNew: () => void;
  onSelectConnectByID: () => void;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 3rem;
  animation: fadeIn 0.3s ease;

  @media (max-width: 768px) {
    padding: 1rem;
    align-items: center;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background: var(--bg-sidebar);
  padding: 2rem 2rem 1.75rem;
  border-radius: 1rem;
  width: 90%;
  max-width: 440px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  animation: modalSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    padding: 1.5rem 1.25rem 1.5rem;
  }

  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h2 {
    font-size: 1.25rem;
    margin: 0 0 1.25rem 0;
    font-family: 'Poppins', sans-serif;
    color: var(--accent-orange);
    font-weight: 900;
    text-align: left;
    letter-spacing: -0.02em;
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
`;

const OptionButton = styled.button`
  padding: 0.65rem 1rem;
  background: #fff;
  border: 2px solid var(--card-border, #e0e6ed);
  border-radius: 0.5rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text-gray);
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  white-space: nowrap;
  min-height: 2.5rem;

  &:hover {
    border-color: var(--accent-orange);
    color: var(--accent-orange);
    background: #fff;
  }

  &:active {
    background: #f8f8f8;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.25rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: stretch;
    gap: 0.75rem;
    margin-top: 1.25rem;
  }
`;

const Button = styled.button`
  padding: 0.6rem 1.25rem;
  border-radius: 0.5rem;
  border: 2px solid var(--accent-orange);
  background: transparent;
  color: var(--accent-orange);
  font-family: 'Poppins', sans-serif;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 120px;
  min-height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
    padding: 0.6rem 1rem;
    min-height: 2.75rem;
  }

  &:hover {
    background: var(--accent-orange);
    color: #fff;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  span {
    position: relative;
    z-index: 1;
  }
`;

const AthleteChoiceModal: React.FC<AthleteChoiceModalProps> = ({ onClose, onSelectCreateNew, onSelectConnectByID }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <h2>Add New Athlete</h2>
        <OptionsContainer>
          <OptionButton onClick={onSelectCreateNew}>
            Add new athlete
          </OptionButton>
          <OptionButton onClick={onSelectConnectByID}>
            I have an ID of an Athlete
          </OptionButton>
        </OptionsContainer>
        <ButtonGroup>
          <Button type="button" onClick={onClose}>
            <span>Cancel</span>
          </Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AthleteChoiceModal;


